<template>
  <px-custom-dialog transition="fadet"
                    width="550"
                    v-model="dialog">
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on">
      </slot>
    </template>
    <template v-slot:title>
      Editando fornecedor
    </template>
    <template>
      <v-row dense>
        <v-col cols="12">
          <px-autocomplete-user-fornecedor dense
                                           v-model="fornecedor.user"
                                           class="rounded-tag-small"
                                           :id-fornecedor="this.currentFornecedor.fornecedor.id" />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-text-field
            dense
            outlined
            hide-details
            maxlength="250"
            label="Código interno"
            class="rounded-tag-small"
            v-model="fornecedor.codigoInterno"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-textarea
            outlined
            auto-grow
            label="Observações internas"
            counter="1500"
            rows="3"
            class="rounded-tag-small"
            v-model="fornecedor.observacoesInternas"
          />
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-btn color="primary"
             class="normal-btn-text rounded-tag-small elevation-0"
             :loading="loading"
             :disabled="$v.$invalid"
             @click="save">
        Salvar
      </v-btn>
      <v-btn text class="normal-btn-text" @click="close">
        Cancelar
      </v-btn>
    </template>
  </px-custom-dialog>
</template>

<script>
import { email } from 'vuelidate/lib/validators';
import GestaoFornecedorService from '../../gestao-fornecedor-service';
import PxAutocompleteUserFornecedor from '../PxAutocompleteUserFornecedor.vue';

export default {
  props: {
    currentFornecedor: Object,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      fornecedor: {
        codigoInterno: null,
        user: null,
        observacoesInternas: null,
      },
    };
  },
  methods: {
    close() {
      this.dialog = false;
    },
    initialState() {
      this.fornecedor.user = this.currentFornecedor.user;
      this.fornecedor.observacoesInternas = this.currentFornecedor.observacoesInternas;
      this.fornecedor.codigoInterno = this.currentFornecedor.codigoInterno;
    },
    buildPayload() {
      const fornecedor = { ...this.fornecedor };
      fornecedor.observacoesInternas = fornecedor.observacoesInternas || null;
      fornecedor.user = fornecedor.user || null;
      fornecedor.codigoInterno = fornecedor.codigoInterno || null;
      return fornecedor;
    },
    save() {
      this.loading = true;
      GestaoFornecedorService.update(this.currentFornecedor.id, this.buildPayload())
        .then(() => {
          this.close();
          this.$emit('update');
          this.$toast('Fornecedor atualizado', { color: 'success' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    dialog(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.initialState();
    },
  },
  validations: {
    fornecedor: {
      email: {
        email,
      },
    },
  },
  components: {
    PxAutocompleteUserFornecedor,
  },
};
</script>
